import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import AboutPage from '../Components/About/AboutPage';
import BlogPage from '../Components/Blog/BlogPage';
import ContactPage from '../Components/Contact/ContactPage';
import HomePage from '../Components/Home/HomePage';
import PageNotFound from '../Components/PageNotFound/PageNotFound';
import ProjectsPage from '../Components/Projects/ProjectsPage';
import NavBar from '../SharedComponents/NavBar/NavBar';

const Routes = () => {

    const location = useLocation();

    return (
        <>
            <NavBar />
            <AnimatePresence exitBeforeEnter initial={false}>
                <Switch location={location} key={location.pathname}>
                    <Route path="/" exact>
                        <HomePage />
                    </Route>
                    <Route path="/contact" exact>
                        <ContactPage />
                    </Route>
                    <Route path="/about" exact>
                        <AboutPage />
                    </Route>
                    <Route path="/projects" exact>
                        <ProjectsPage />
                    </Route>
                    <Route path="/blog" exact>
                        <BlogPage />
                    </Route>
                    <Route>
                        <PageNotFound />
                    </Route>
                </Switch>
            </AnimatePresence>
        </>
    )
}

export default Routes
